/**
 * Navigation state a page puts on its own URL bookkeeping — a view or an open
 * item written into the URL with `replace` — so `ScrollToTop` leaves the
 * reader where they are. Without it, the first such write after a load turns
 * the navigation type from POP (or PUSH) into REPLACE and scrolls the page to
 * the top mid-read (`same-url-link-clicks-replace`).
 */
const KEEP_SCROLL = 'keepScroll';

type NavigationState = Record<string, unknown>;

/** `state`, kept whole (it may name where Back goes), marked to keep scroll. */
export function withKeptScroll(state: unknown): NavigationState {
  const base =
    state && typeof state === 'object' ? (state as NavigationState) : {};
  return { ...base, [KEEP_SCROLL]: true };
}

export function keepsScroll(state: unknown): boolean {
  return (
    Boolean(state) &&
    typeof state === 'object' &&
    (state as NavigationState)[KEEP_SCROLL] === true
  );
}
